/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Store from '../../store/store';
import { removeMember, restoreMember } from '../../actions/teamActions';
import { openModal } from '../../actions/modalActions';
import modalTypes from '../../constants/modalTypes';
import { allows } from '../../utils/authorization';

const UpdateMember = props => {
  const { classes, user, team, currentUser } = props;

  if (!user && !user.id && !team && !team.id) return null;

  const allowEdit =
    allows('update_user_users', {
      organization_id:
        user.organizations && user.organizations.length > 0
          ? user.organizations[0].id
          : -1
    }) || user.id === currentUser.id;

  const deleted = team.deleted_member_ids.includes(user.id);

  return (
    <ul className={`dropdown-menu result-dropdown-menu ${classes}`}>
      {allowEdit && (
        <li>
          <a
            onClick={() =>
              Store.dispatch(
                openModal(modalTypes.editUser, {
                  user,
                  modalId: 'EDIT_USER',
                  editExistingUser: true
                })
              )
            }
          >
            <span>Edit Member</span>
          </a>
        </li>
      )}
      <li>
        <a onClick={() => Store.dispatch(removeMember(team.id, user.id))}>
          <span>Remove Member</span>
        </a>
      </li>
      {deleted && (
        <li>
          <a onClick={() => Store.dispatch(restoreMember(team.id, user.id))}>
            <span>Restore Member</span>
          </a>
        </li>
      )}
    </ul>
  );
};

UpdateMember.propTypes = {
  task: PropTypes.object,
  currentUser: PropTypes.object,
  users: PropTypes.array,
  classes: PropTypes.string
};

UpdateMember.defaultProps = {
  classes: '',
  users: [],
  task: {},
  currentUser: {}
};

export default UpdateMember;
